export const defaultSwitchSelections = {
  'Organization Viewer': true,
  'Project Creator': true,
  'Project Browser': true,
};

export const requiredPermissions = [
  'resourcemanager.organizations.get',
  'resourcemanager.organizations.setIamPolicy',
  'orgpolicy.policy.get',
];

export const organizationViewerProps = {
  disabled: true,
  permissionName: 'Organization Viewer',
  permissionId: 'organization-viewer',
  permissionInfo: () => (
    <>
      <strong>Required: </strong>
      <span>Allows Rackspace to view basic organization details like name, domain, and id.</span>
    </>
  ),
};

export const projectBrowserProps = {
  disabled: false,
  clickableClass: 'cursor-pointer form-label',
  permissionName: 'Project Browser',
  permissionId: 'project-browser',
  permissionInfo: () => (
    <>
      <span>
        Allows Rackspace to browse project information in your Google organization.
      </span>
      <span>
        This role does not include permisson to view resources in projects or list the contents of storage buckets.
      </span>
    </>
  ),
};

export const projectCreatorProps = {
  disabled: false,
  clickableClass: 'cursor-pointer form-label',
  permissionName: 'Project Creator',
  permissionId: 'project-creator',
  permissionInfo: () => (
    <>
      <span>Allows Rackspace and you to create additional projects in your Google organization.</span>
    </>
  ),
};
